import axios from 'axios';
import env from './env';

const api = axios.create({ baseURL: env('REACT_APP_BUNKER_API') })

export default api;